import Vue from 'vue';
import VueResource from 'vue-resource';
import converterMoeda from '~js/converter-moeda';
import formatarData from '~js/formatar-data';
import converterObjetoFormData from '~js/converter-objeto-formdata';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

async function normalizarParaSalvar(solicitacao) {
  delete solicitacao.rateio.projeto;
  delete solicitacao.rateio.projetoMetaEtapa;
  delete solicitacao.rateio.detalheRateio;
  delete solicitacao.solicitante;
  delete solicitacao.protocolo;
  delete solicitacao.rubrica;
  delete solicitacao.subrubrica;
  delete solicitacao.conta;

  // solicitacao.rateio.valorRateio = converterMoeda.paraDolar(solicitacao.rateio.valorRateio);
  
  if (solicitacao.dataPagamento) {
    solicitacao.dataPagamento = await formatarData.paraNumero(solicitacao.dataPagamento);
  }
  if (solicitacao.dataNascimento) {
    solicitacao.dataNascimento = await formatarData.paraNumero(solicitacao.dataNascimento);
  }
  if (solicitacao.dataEmissao) {
    solicitacao.dataEmissao = await formatarData.paraNumero(solicitacao.dataEmissao);
  }
  if (solicitacao.dataVencimento) {
    solicitacao.dataVencimento = await formatarData.paraNumero(solicitacao.dataVencimento);
  }

  if (solicitacao.funcionarioPublico == 1)
    solicitacao.funcionarioPublico = true;

  if (solicitacao.funcionarioPublico == 0)
    solicitacao.funcionarioPublico = false;

  if (solicitacao.pertenceQuadroUSP == 1)
    solicitacao.pertenceQuadroUSP = true;

  if (solicitacao.pertenceQuadroUSP == 0)
    solicitacao.pertenceQuadroUSP = false;

  if (solicitacao.solicitacaoAnexouArquivo != null) {
    solicitacao.solicitacaoAnexouArquivo = solicitacao.solicitacaoAnexouArquivo == 1 ? true : false;
  }

  return solicitacao;
}

function normalizarParaVisualizar(solicitacao) {
  solicitacao.rateio.valorRateio = converterMoeda.paraReal(solicitacao.rateio.valorRateio);

  if (solicitacao.inss) {
    solicitacao.inss = solicitacao.inss.replace('   .     .  / ', "");
  }

  if (solicitacao.pispasep) {
    solicitacao.pispasep = solicitacao.pispasep.replace('   .     .  / ', "");
  }

  if (solicitacao.solicitacaoPJAnexouNF != null) {
    solicitacao.solicitacaoPJAnexouNF = solicitacao.solicitacaoPJAnexouNF ? 'true' : 'false';
  }

  if (solicitacao.solicitacaoPJAnexouBoleto != null) {
    solicitacao.solicitacaoPJAnexouBoleto = solicitacao.solicitacaoPJAnexouBoleto ? 'true' : 'false';
  }

  if (solicitacao.funcionarioPublico != null) {
    if (solicitacao.funcionarioPublico == true)
      solicitacao.funcionarioPublico = 1;

    if (solicitacao.funcionarioPublico == false)
      solicitacao.funcionarioPublico = 0;
  }

  if (solicitacao.pertenceQuadroUSP != null) {
    if (solicitacao.pertenceQuadroUSP == true)
      solicitacao.pertenceQuadroUSP = 1;

    if (solicitacao.pertenceQuadroUSP == false)
      solicitacao.pertenceQuadroUSP = 0;
  }

  if (solicitacao.solicitacaoAnexouArquivo != null) {
    solicitacao.solicitacaoAnexouArquivo = solicitacao.solicitacaoAnexouArquivo ? 'true' : 'false';
  }

  return solicitacao;
}

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);
    
    const periodo = parametros.periodo;
    delete parametros.periodo;
    
    if (periodo) {
      parametros.dataInicio = moment(periodo[0], 'DD/MM/YYYY').format('MM/DD/YYYY');
      parametros.dataFim = moment(periodo[1], 'DD/MM/YYYY').format('MM/DD/YYYY');
    }

    return Vue.http.get('/api/solicitacaopagamentos', { params: parametros });
  },
  adicionar: async (solicitacao, arquivos) => {
    solicitacao = await normalizarParaSalvar(solicitacao);
    solicitacao.arquivos = arquivos;

    solicitacao = await converterObjetoFormData(solicitacao);

    return Vue.http.post('/api/solicitacaopagamentos', solicitacao).then(res => res.data.id);
  },
  alterar: async (solicitacao, arquivos, id) => {
    solicitacao = await normalizarParaSalvar(solicitacao, id);
    solicitacao.arquivos = arquivos;

    solicitacao = await converterObjetoFormData(solicitacao);
    
    return Vue.http.put(`/api/solicitacaopagamentos/${id}`, solicitacao).then(res => res.data.id);
  },
  obterPorId: id => {
    return Vue.http.get(`/api/solicitacaopagamentos/${id}`)
      .then(response => response.data)
      .then(solicitacao => normalizarParaVisualizar(solicitacao));
  },
  liberar: id => {
    return Vue.http.post(`/api/solicitacaopagamentos/${id}/liberar`)
      .then(response => response.data);
  },
  cancelar: id => {
    return Vue.http.post(`/api/solicitacaopagamentos/${id}/cancelar`)
      .then(response => response.data);
  },
  reenviarEmail: id => {
    return Vue.http.get(`/api/solicitacaopagamentos/${id}/reenviaremail`)
      .then(response => response.data);
  },
  arquivos: id => {
    return Vue.http.get(`/api/solicitacaopagamentos/${id}/arquivos`)
            .then(response => response.data);
  },
  listaMoedas: function () {
    return Vue.http.get('/api/solicitacaopagamentos/moedas').then(response => response.data);
  },
  download: (id, arquivo) => {
    return Vue.http.get(`/api/solicitacaopagamentos/${id}/downloadarquivo/${arquivo}`, {
      responseType: 'blob'
    })
      .then(response => {
        return salvarArquivo(response, arquivo);
      });
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-pagamento/servico.js